export default [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../pages/AdminLoginPage.vue'),
    meta: {}
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../pages/AdminDashboardPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/site-content',
    name: 'AdminSiteTexts',
    component: () => import('../pages/AdminSiteTextsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: () => import('../pages/AdminProductsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('../pages/AdminUsersPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/users/:id',
    name: 'AdminUserDetail',
    component: () => import('../pages/AdminUserDetailPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/transactions',
    name: 'AdminTransactions',
    component: () => import('../pages/AdminTransactionsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/payments',
    name: 'AdminPayments',
    component: () => import('../pages/AdminPaymentsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/credits',
    name: 'AdminCredits',
    component: () => import('../pages/AdminCreditsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/withdrawals',
    name: 'AdminWithdrawals',
    component: () => import('../pages/AdminWithdrawalsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/currencies',
    name: 'AdminCurrencies',
    component: () => import('../pages/AdminCurrenciesPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/countries',
    name: 'AdminCountries',
    component: () => import('../pages/AdminCountriesPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/static-texts',
    name: 'AdminStaticTexts',
    component: () => import('../pages/AdminStaticTextsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/faq',
    name: 'AdminFaq',
    component: () => import('../pages/AdminStaticTextEditPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/static-texts/:id',
    name: 'AdminStaticTextEdit',
    component: () => import('../pages/AdminStaticTextEditPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    component: () => import('../pages/AdminSettingsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]
